import * as yup from 'yup'

export class ValidationError extends yup.ValidationError {}
